import React from "react"
import PropTypes from "prop-types"
import { Card, CardBody, CardHeader } from "reactstrap"

import Header from "components/Common/Header"

const TitleAndInformation = ({
  onEdit,
  onClone,
  onDelete,
  onCancel,
  children,
  title,
  subtitle,
  icon,
  resource,
  external,
  customButtons,
  isHideEdit,
  isHideCancel,
  isHideDelete,
  isDisableClone,
  isDropDown
}) => {
  return (
    <Card>
      <CardHeader className="bg-transparent border-bottom">
        <Header
          onEdit={onEdit}
          onClone={onClone}
          onDelete={onDelete}
          onCancel={onCancel}
          buttons
          customButtons={customButtons}
          title={title}
          subtitle={subtitle}
          iconClass={icon}
          resource={resource}
          external={external}
          isHideEdit={isHideEdit}
          isHideCancel={isHideCancel}
          isHideDelete={isHideDelete}
          isDisableClone={isDisableClone}
          isDropDown={isDropDown}
        />
      </CardHeader>

      <CardBody>{children}</CardBody>
    </Card>
  )
}

TitleAndInformation.propTypes = {
  onEdit: PropTypes.func,
  onClone: PropTypes.func,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  resource: PropTypes.string.isRequired,
}

TitleAndInformation.defaultProps = {
  onEdit: () => { },
  onClone: () => { },
  onDelete: () => { },
  onCancel: () => { },
}

export default TitleAndInformation
